/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryManagerResponse
 */
export interface CountryManagerResponse {
    /**
     * 
     * @type {string}
     * @memberof CountryManagerResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CountryManagerResponse
     */
    fullname: string;
}

/**
 * Check if a given object implements the CountryManagerResponse interface.
 */
export function instanceOfCountryManagerResponse(value: object): value is CountryManagerResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullname' in value) || value['fullname'] === undefined) return false;
    return true;
}

export function CountryManagerResponseFromJSON(json: any): CountryManagerResponse {
    return CountryManagerResponseFromJSONTyped(json, false);
}

export function CountryManagerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryManagerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullname': json['fullname'],
    };
}

export function CountryManagerResponseToJSON(value?: CountryManagerResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'fullname': value['fullname'],
    };
}

